import { partCapacity, partCapacityError } from '../services/mapPartLimits'
import { mapCellAt } from '../services/mapInspectionDetails'
// 点位表单的临时标记只用于编辑预览，应用后才进入地图草稿。
export default {
  data () { return { pointLocated: false, pointBatchMode: false, pointBatchLocations: [] } },
  computed: {
    selectedPartCapacity () { return partCapacity(this.parts, this.partPoints, this.pointForm.key) },
    pointCapacityWarning () { return this.pointForm.key ? partCapacityError(this.parts, this.partPoints, this.pointForm.key, this.pointBatchMode ? this.pointBatchLocations.length : this.pendingPointChanges ? 1 : 0, this.editedPoint) : '' },
    pointPreview () {
      if (!this.pointEditorOpen || this.readOnly || this.pointBatchMode || !this.pointLocated) return null
      const part = this.parts.find(part => part.key === this.pointForm.key)
      const { x, y } = this.pointForm
      if (!part || x === '' || y === '' || x == null || y == null) return null
      if (!Number.isFinite(Number(x)) || !Number.isFinite(Number(y)) || x < 0 || x > this.mapWidth || y < 0 || y > this.mapHeight) return null
      return { ...this.pointForm, x: Number(x), y: Number(y), name: this.pointForm.name || part.name + '（待新增）' }
    },
    mapPointMarkers () {
      return this.partPoints.map(point => this.pointPreview && point.id === this.editedPoint
        ? { ...this.pointPreview, id: point.id } : point)
    },
    batchPointPreviews () {
      const part = this.parts.find(part => part.key === this.pointForm.key)
      if (!this.pointEditorOpen || this.readOnly || !this.pointBatchMode || !part) return []
      const prefix = this.pointForm.name || part.name
      return this.pointBatchLocations.map((point, index) => ({ ...point, key: part.key, name: prefix + (index + 1), order: index + 1 }))
        .filter(point => this.validPointCoordinates(point))
    },
    pendingPointChanges () {
      if (!this.pointEditorOpen || this.readOnly) return false
      if (this.pointBatchMode) return this.pointBatchLocations.length > 0
      if (!this.editedPoint) return this.pointLocated
      const original = this.partPoints.find(point => point.id === this.editedPoint)
      return !!original && JSON.stringify(original) !== JSON.stringify(this.pointForm)
    }
  },
  methods: {
    resetPointEditor (close = false) {
      this.editedPoint = ''; this.pointLocated = false; this.pointPicking = false
      this.pointBatchMode = false; this.pointBatchLocations = []
      this.pointForm = { id: '', name: '', key: this.parts[0]?.key || '', x: 0, y: 0 }
      if (close) this.pointEditorOpen = false
    },
    closePointEditor () { this.resetPointEditor(true) },
    setPointBatchMode (batch) {
      if (this.readOnly || this.saving || this.editedPoint || batch === this.pointBatchMode) return
      if (batch) {
        const preview = this.pointPreview
        if (this.pointLocated && !preview) return this.fail({ message: '请先修正或移除当前无效的定位，再切换批量添加' })
        this.pointBatchLocations = preview ? [{ localId: window.crypto.randomUUID(), x: preview.x, y: preview.y }] : []
        this.pointLocated = false
      } else {
        if (this.pointBatchLocations.length > 1) return this.fail({ message: '请先批量新增或清空已选点位，再切换为单点添加' })
        const point = this.pointBatchLocations[0]
        this.pointLocated = !!point
        if (point) { this.pointForm.x = point.x; this.pointForm.y = point.y }
        this.pointBatchLocations = []
      }
      this.pointBatchMode = batch; this.pointPicking = false
    },
    startPointPicking () {
      if (this.readOnly || this.saving) return
      if (!this.parts.some(part => part.key === this.pointForm.key)) return this.fail({ message: '请先新增并选择有效的部件类型，再在地图定位' })
      if (!this.pointBatchMode || !this.pointBatchLocations.length) {
        const error = partCapacityError(this.parts, this.partPoints, this.pointForm.key, 1, this.editedPoint)
        if (error) return this.fail({ message: error })
      }
      this.cancelDraw(); this.schemeSelecting = false; this.mapPanMode = false
      this.stopSceneDrawing()
      this.pointPicking = true; this.layerSwitches.POINTS = true
    },
    previewPointCoordinates () {
      if (!this.readOnly && !this.saving && !this.pointBatchMode) this.pointLocated = true
    },
    locatePoint (x, y) {
      if (this.pointBatchMode) return this.selectBatchPoint(x, y)
      const error = partCapacityError(this.parts, this.partPoints, this.pointForm.key, 1, this.editedPoint)
      if (error) return this.fail({ message: error })
      this.pointForm.x = x; this.pointForm.y = y
      this.pointLocated = true; this.pointPicking = false; this.layerSwitches.POINTS = true
    },
    mapPointClick (point, event) {
      if (this.drawing || this.pointPicking || this.sceneDrawingActive) return this.handleMapClick(event)
      if (this.schemeSelecting || this.editorTab === 'cells') { const cell = mapCellAt(this.previewTemplate, point.x, point.y); if (cell) this.mapCellClick(cell, event); return }
      if (!this.checkSceneApplied()) return
      this.editPoint(point)
    },
    editPoint (point) {
      if (this.saving) return
      if (this.pendingPointChanges) { if (this.editedPoint === point.id) return; this.checkPointApplied(); return }
      if (!this.checkSceneApplied()) return
      if (this.pointBatchMode && this.pointBatchLocations.length) return this.fail({ message: '请先批量新增或清空已选点位，再编辑已有点位' })
      this.resetPointEditor()
      this.pointForm = { ...point }; this.editedPoint = point.id; this.pointLocated = true
      this.pointEditorOpen = true; this.openEditorTab('points')
    },
    applyPoint () {
      if (this.pointBatchMode) return this.applyBatchPoints()
      if (this.readOnly || this.saving) return false
      const p = { ...this.pointForm, id: String(this.pointForm.id || '').trim() || window.crypto.randomUUID(), x: Number(this.pointForm.x), y: Number(this.pointForm.y) }
      if (!p.name || !this.parts.some(type => type.key === p.key) || this.pointForm.x === '' || this.pointForm.y === '' || this.pointForm.x == null || this.pointForm.y == null || !Number.isFinite(p.x) || !Number.isFinite(p.y) || p.x < 0 || p.x > this.mapWidth || p.y < 0 || p.y > this.mapHeight) {
        this.fail({ message: '点位需填写名称、有效部件类型和地图范围内坐标' }); return false
      }
      if (this.partPoints.some(point => point.id === p.id && point.id !== this.editedPoint)) {
        this.fail({ message: '点位编号不能重复' }); return false
      }
      const capacityError = partCapacityError(this.parts, this.partPoints, p.key, 1, this.editedPoint)
      if (capacityError) { this.fail({ message: capacityError }); return false }
      if (this.editedPoint) this.partPoints = this.partPoints.map(point => point.id === this.editedPoint ? p : point)
      else this.partPoints.push(p)
      this.resetPointEditor()
      this.ok('城市部件点位已应用到草稿，请保存')
      return true
    },
    removeCurrentPoint () {
      if (this.readOnly || this.saving) return
      if (this.pointBatchMode) return this.clearBatchPoints()
      if (this.editedPoint) return this.removePoint({ id: this.editedPoint })
      this.pointLocated = false; this.pointPicking = false
      this.pointForm.x = 0; this.pointForm.y = 0
      this.ok('待新增点位已移除，可重新在地图定位')
    },
    removePoint (point) {
      if (this.readOnly || this.saving || !this.partPoints.some(item => item.id === point.id)) return
      this.partPoints = this.partPoints.filter(item => item.id !== point.id)
      if (this.editedPoint === point.id) this.resetPointEditor(true)
      this.pointPage = this.currentPointPage
      this.ok('点位已从草稿移除，请保存地图配置')
    },
    checkPointApplied () {
      if (!this.pendingPointChanges) return true
      this.openEditorTab('points'); this.mapConfigCollapsed = false
      this.fail({ message: this.pointBatchMode ? '批量点位仍在预览中，请先批量新增到草稿，或清空已选点位后再保存' : '点位仍在预览中，请先点击“' + (this.editedPoint ? '应用点位修改' : '新增城市部件点位') + '”，或移除点位、返回点位列表后再保存' })
      return false
    },
    validPointCoordinates (point) {
      return point.x !== '' && point.y !== '' && point.x != null && point.y != null &&
        Number.isFinite(Number(point.x)) && Number.isFinite(Number(point.y)) &&
        point.x >= 0 && point.x <= this.mapWidth && point.y >= 0 && point.y <= this.mapHeight
    },
    pointPositionKey (point) { return Number(point.x) + ',' + Number(point.y) },
    selectBatchPoint (x, y) {
      if (this.readOnly || this.saving || !this.pointPicking) return
      if (!this.parts.some(part => part.key === this.pointForm.key)) return this.fail({ message: '请先选择有效的部件类型' })
      const scale = Math.hypot(this.$refs.mapSvg?.getScreenCTM()?.a || 1, this.$refs.mapSvg?.getScreenCTM()?.b || 0)
      const radius = 6 / Math.max(.01, scale)
      const selected = this.pointBatchLocations.find(point => Math.hypot(point.x - x, point.y - y) <= radius)
      if (selected) return this.removeBatchPoint(selected.localId)
      if (this.partPoints.some(point => point.key === this.pointForm.key && Math.hypot(Number(point.x) - x, Number(point.y) - y) <= radius)) {
        return this.fail({ message: '此位置已有同类型点位，请选择其他位置' })
      }
      if (!this.validPointCoordinates({ x, y })) return this.fail({ message: '点位坐标必须位于地图范围内' })
      const capacityError = partCapacityError(this.parts, this.partPoints, this.pointForm.key, this.pointBatchLocations.length + 1)
      if (capacityError) return this.fail({ message: capacityError })
      this.pointBatchLocations.push({ localId: window.crypto.randomUUID(), x, y })
      this.layerSwitches.POINTS = true; this.isError = false; this.message = ''
    },
    batchPointClick (point, event) {
      if (this.drawing) return this.handleMapClick(event)
      this.removeBatchPoint(point.localId)
    },
    removeBatchPoint (id) {
      if (this.readOnly || this.saving) return
      this.pointBatchLocations = this.pointBatchLocations.filter(point => point.localId !== id)
    },
    clearBatchPoints () {
      if (this.readOnly || this.saving) return
      this.pointBatchLocations = []; this.pointPicking = false
    },
    applyBatchPoints () {
      if (this.readOnly || this.saving || !this.pointBatchMode) return false
      const part = this.parts.find(part => part.key === this.pointForm.key)
      if (!part || !this.pointBatchLocations.length) { this.fail({ message: '请选择有效部件类型，并在地图批量点选位置' }); return false }
      const capacityError = partCapacityError(this.parts, this.partPoints, part.key, this.pointBatchLocations.length)
      if (capacityError) { this.fail({ message: capacityError }); return false }
      const positions = new Set(this.partPoints.filter(point => point.key === part.key).map(point => this.pointPositionKey(point)))
      const ids = new Set(this.partPoints.map(point => point.id))
      const names = new Set(this.partPoints.filter(point => point.key === part.key).map(point => point.name))
      const idPrefix = String(this.pointForm.id || '').trim(), namePrefix = String(this.pointForm.name || '').trim() || part.name
      const points = []; let idNumber = 1; let nameNumber = 1
      for (const location of this.pointBatchLocations) {
        const position = this.pointPositionKey(location)
        if (!this.validPointCoordinates(location) || positions.has(position)) {
          this.fail({ message: '所选位置存在越界或同类型重复点位，请调整后重新批量新增' }); return false
        }
        let id = location.localId
        if (idPrefix) { while (ids.has(idPrefix + '-' + idNumber)) idNumber++; id = idPrefix + '-' + idNumber++ }
        if (ids.has(id)) { this.fail({ message: '点位编号冲突，请重新点选' }); return false }
        while (names.has(namePrefix + nameNumber)) nameNumber++
        const name = namePrefix + nameNumber++
        points.push({ id, name, key: part.key, x: Number(location.x), y: Number(location.y) })
        ids.add(id); names.add(name); positions.add(position)
      }
      this.partPoints = this.partPoints.concat(points)
      this.pointBatchLocations = []; this.pointPicking = false
      this.ok('已批量新增 ' + points.length + ' 个' + part.name + '点位到草稿，请保存地图配置')
      return true
    }
  }
}
